<template>
  <v-layout align-center justify-center my-3 v-if="category">
    <v-flex sm12 md8 lg6>
      <h1 class="decorated">
        <span class="display-1 font-weight-light thin-border">{{ $t(category.title) }}</span>
      </h1>
      <p class="pre-wrap mt-2">{{ seoProxyTexts }}</p>
      <div class="text-xs-center">
        <tk-btn
          class="more-btn"
          small
          outline
          @click="seoTextsExtended = !seoTextsExtended"
        >{{ seoTextsExtended ? $t('COMMON.LESS') : $t('COMMON.MORE') }}</tk-btn>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { categorySeoTexts, categories } from "@/config";

export default {
  data: () => ({
    category: null,
    seoTexts: "",
    seoTextsExtended: false
  }),

  computed: {
    seoProxyTexts() {
      // const excerptLength = this.$vuetify.breakpoint.smAndDown ? 150 : 350;
      const excerptLength = 150;

      console.log({excerptLength});

      return !this.seoTextsExtended && this.seoTexts.length > excerptLength
        ? this.seoTexts.substring(0, excerptLength + 1) + "..."
        : this.seoTexts;
    }
  },

  watch: {
    "$route.query": {
      immediate: true,
      handler: function(val) {
        this.mapCategoryFromQuery(val);
      }
    }
  },

  methods: {
    mapCategoryFromQuery(query) {
      console.log("mapCategoryFromQuery", query);

      if (query.techs) {
        const techSlugs = query.techs.split(",").sort();

        this.category = categories.find(cat => {
          console.log(cat.slug);
          const techniques = cat.techniques.sort();
          console.log({ techniques, techSlugs });
          return techniques.join(",") === techSlugs.join(",");
        });
      } else {
        this.category = null;
      }

      console.log("Selected category", this.category);
      this.mapSeoTexts();
    },

    mapSeoTexts() {
      console.log("MapSeoTexts", this.category);
      if (!this.category) return;
      const slug = this.category.slug;
      const texts = categorySeoTexts[slug];

      console.log(texts);
      if (texts) {
        this.seoTexts = texts[this.$i18n.locale];
      }
    }
  }
};
</script>